import { FC, useEffect, useState } from 'react';
import { Modal, ModalProps, Radio } from 'antd';
import { HOST_MAP, getHost, setHost } from '@/util/host';
import './index.less';

const SwitchHostModal: FC<ModalProps> = ({ open, ...resetProps }) => {
    const [value, setValue] = useState<string | null>(null);
    const hostList = Object.entries(HOST_MAP).map(([key, value]) => {
        return {
            value: key,
            label: `${key}/${value}`,
        };
    });

    useEffect(() => {
        setValue(getHost().xiaobBaseUrl.replace('//', ''));
    }, [open]);

    const handleHostChange = (e: any) => {
        const { value } = e.target;
        setHost(value);
        window.location.reload();
    };
    return (
        <Modal title="环境切换" open={open} {...resetProps} footer={null}>
            <div className="host-wrap">
                <Radio.Group
                    size="large"
                    options={hostList}
                    value={value}
                    onChange={handleHostChange}
                ></Radio.Group>
            </div>
        </Modal>
    );
};

export default SwitchHostModal;
